module.exports = __webpack_public_path__ + "static/media/postcard-intro-1.0df6180d.png";